import {
  FacebookTargetingSpec,
  Gender,
  LocationCustomTargetSpec,
  LocationTargetSpec,
  LocationType,
} from './Targeting';

export interface FacebookSavedAudience {
  id: string;
  approximate_count_lower_bound: number;
  approximate_count_upper_bound: number;
  name: string;
  run_status: 'ACTIVE';
  time_created?: string;
  time_updated: string;
  targeting: FacebookTargetingSpec;
}

export interface SavedAudienceStandardTargetingSpec
  extends FacebookTargetingSpec {
  genders: Gender[];
  geo_locations: SavedAudienceStandardGeoLocationTargetingSpec;
}

export const exampleSavedAudienceTargetingSpec: SavedAudienceStandardTargetingSpec = {
  age_max: 30,
  age_min: 20,
  genders: [1],
  geo_locations: {
    countries: ['US', 'CA'],
    custom_locations: [],
    location_types: [LocationType.Home, LocationType.Recent],
  },
};

export interface SavedAudienceStandardGeoLocationTargetingSpec
  extends LocationTargetSpec {
  // Find countries from: https://developers.facebook.com/docs/reference/ads-api/get-autocomplete-data/#countries
  countries: string[];
  custom_locations: LocationCustomTargetSpec[];
  location_types: [LocationType.Home, LocationType.Recent];
}
